import { createSelector } from "@reduxjs/toolkit";
const selectLanguage = (state) => state?.locale?.value;

export const manageLocaleSelector = createSelector(
  [selectLanguage],
  (language) => ({
    language,
  })
);
